import { render, staticRenderFns } from "./Compare03.vue?vue&type=template&id=76e889c6&"
import script from "./Compare03.vue?vue&type=script&lang=ts&"
export * from "./Compare03.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports